// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
//master
export const environment = {
  production: false,
   apiUrl:'https://backend.digixvsx.com/api/v1/',
  // apiUrl :'http://172.16.6.130:1808/api/v1/',
  
  // apiUrl :'https://sportsweb-backend.mobiloitte.io/api/v1/',
  
  // apiUrl :'http://localhost:1808/api/v1/',//
  // stripeKeyLive:'pk_live_51J4jyzCYuZhsBWzn5RRD0VpZfKD3Xgk1FipBFmz6TLAk5T62BovFqtVyFZ26VDrQGrjk4MEQjekXnSM4QCocHDMX00lo5TKXHU'
  stripeKeyLive:'pk_live_51J4jyzCYuZhsBWzn5RRD0VpZfKD3Xgk1FipBFmz6TLAk5T62BovFqtVyFZ26VDrQGrjk4MEQjekXnSM4QCocHDMX00lo5TKXHU'
  //  testing strip - pk_test_51KBtzMSI2dwhNfVRFO2Nn5UDEW4AT3I8uUv4FEFz60tVvqSVCfyZ89FmOkLu6zhUB0x1Fhbu2n2JA4C3qGiuAyuw00IKJCL23d
  //dd
};



// WEBPACK FOOTER //
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/environments/environment.ts